import { useDRSContext } from "Pages/DRS/Context/DRSContext";
import { useEffect } from "react";
import dayjs from "dayjs";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
export const getCurrentMonthYear = () => {
  return dayjs().format("YYYY-MM");
};
const useDashboardFilter = (url: string, type: string) => {
  const {
    fetchDRSDashboard,
    paginationDRSFilter,
    drsDashboardFilters,
    isFetchDRSDashboardLoading,
  } = useDRSContext();
  const filters = drsDashboardFilters;
  console.log("filtersfiltersfilters", filters, type);
  useEffect(() => {
    const newURL = getUrlWithFilters(url, ["statuses"]);
    fetchDRSDashboard(newURL, {});
  }, [filters, paginationDRSFilter.current, paginationDRSFilter.pageSize]);
  const getUrlWithFilters = (url: string, deletedFields?: any) => {
    const limit = paginationDRSFilter.pageSize;
    const offset = (paginationDRSFilter.current - 1) * limit;
    let newURL =
      url + `&offset=${offset}&limit=${limit}&sortBy=name&sortDir=ASC`;

    const filters2: any = [];
    const formFilters = { ...filters };
    formFilters["yearMonthStart"] = formFilters["yearMonthStart"]
      ? formFilters["yearMonthStart"]
      : getCurrentMonthYear();
    formFilters["yearMonthEnd"] = formFilters["yearMonthEnd"]
      ? formFilters["yearMonthEnd"]
      : getCurrentMonthYear();
    delete formFilters["dateRange"];
    (deletedFields || [])?.forEach((field: any) => {
      delete formFilters[field];
    });
    const formValues: any = removeEmptyFields(formFilters);
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters2.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters2) && filters2.length > 0) {
      newURL = newURL + "&" + filters2.join("&");
    }
    return newURL;
  };
  return {
    isFetchDRSDashboardLoading,
  };
};

export default useDashboardFilter;
